<div class="logo">
  <img src="../../../assets/img/logo_white.png" alt="">
</div>
